import { render, staticRenderFns } from "./hi-button-link.vue?vue&type=template&id=a6e3be74"
import script from "./hi-button-link.vue?vue&type=script&lang=ts"
export * from "./hi-button-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports